import React from "react";
import "./ColourFilterTile.scss";
import PropTypes from "prop-types";
import classNames from "classnames";

const ColourFilterTile = ({ disabled, selected, name, onClick }) => {
  const cssColour = name ? name.toLowerCase() : null;

  return (
    <div
      className={classNames({
        "filter-tile": true,
        "filter-tile--colour": true,
        "filter-tile--disabled": disabled,
        "filter-tile--selected": selected,
      })}
    >
      <div
        onClick={onClick}
        className={classNames({
          "filter-tile__panel": true,
          [cssColour]: cssColour != null,
        })}
        style={{ backgroundColor: cssColour }}
        title={name}
      >
        <span className="filter-tile__tick"></span>
      </div>
      {name && <div className="filter-tile__label">{name}</div>}
    </div>
  );
};

ColourFilterTile.propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
};

export default ColourFilterTile;
